const ActiveDescending = () => (
  <svg width="10" height="16" fill="none" >
    <path fillRule="evenodd" clipRule="evenodd" d="M0 5l5-5 5 5H0z" fill="#000" fillOpacity=".1" />
    <path fillRule="evenodd" clipRule="evenodd" d="M0 11l5 5 5-5H0z" fill="#000" />
  </svg>
);

export default ActiveDescending;
